"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _iconBase = _interopRequireDefault(require("../icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaSignOut = function FaSignOut(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M640 1440q0 4 1 20t.5 26.5-3 23.5-10 19.5-20.5 6.5H288q-119 0-203.5-84.5T0 1248V544q0-119 84.5-203.5T288 256h320q13 0 22.5 9.5T640 288q0 4 1 20t.5 26.5-3 23.5-10 19.5T608 384H288q-66 0-113 47t-47 113v704q0 66 47 113t113 47h312l11.5 1 11.5 3 8 5.5 7 9 2 13.5zm928-544q0 26-19 45l-544 544q-19 19-45 19t-45-19-19-45v-288H448q-26 0-45-19t-19-45V704q0-26 19-45t45-19h448V352q0-26 19-45t45-19 45 19l544 544q19 19 19 45z"
  })));
};

FaSignOut.defaultProps = {
  viewBox: '0 0 1664 1896.083',
  height: '1em',
  width: '0.8776em'
};
FaSignOut.displayName = 'FaSignOut';
var _default = FaSignOut;
exports.default = _default;